import React, { useState } from 'react';
import css from './FilterPanel.module.css';
import MottoCard from './MottoCard';
import arrayMutators from 'final-form-arrays';

import { FieldCheckbox, FieldCheckboxGroup, FieldTextInput } from '../../../components';
import { Form as FinalForm, useField } from 'react-final-form';
import Select from 'react-select';
import { flags } from '../../../components/Tag/TagComponent';
import { FormattedMessage, useIntl } from 'react-intl';
import { useConfiguration } from '../../../context/configurationContext';
import LocationField from './LocationField';

const CappaFilterPanel = props => {
  const [dirtyOverride, setDirtyOverride] = useState(false);
  const { formatMessage } = useIntl();
  const { location, setFilters, validQueryParams, submitFilters } = props;

  const onEnterKey = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submitFilters();
    }
  };

  return (
    <FinalForm
      mutators={{ ...arrayMutators }}
      initialValues={{
        location: location?.address,
      }}
      onSubmit={values => {
        console.log('Form submitted with values:', values);
      }}
      render={formRenderProps => {
        const { dirtyFields, values } = formRenderProps?.form?.getState();

        if (!dirtyOverride) {
          console.log({ validQueryParams });
          if (!dirtyFields?.keywords && validQueryParams?.keywords) {
            formRenderProps?.form?.change('keywords', validQueryParams?.keywords);
            setFilters({
              keywords: validQueryParams?.keywords,
            });
          }
          const servicesTmp = validQueryParams?.pub_services?.replace('has_all:', '').split(',');
          if (!dirtyFields?.services && servicesTmp?.length > 0) {
            formRenderProps?.form?.change('services', servicesTmp);
            setFilters({
              pub_services: servicesTmp,
            });
          }
          if (!dirtyFields?.location && validQueryParams?.location) {
            formRenderProps?.form?.change('location', location?.address);
            setFilters({
              location: location?.address,
            });
          }

          if (!dirtyFields?.price_min && validQueryParams?.pub_price_min) {
            formRenderProps?.form?.change(
              'price_min_min',
              validQueryParams?.pub_price_min.split(',')[0]
            );
            setFilters({
              pub_price_min_min: validQueryParams?.pub_price_min.split(',')[0],
            });
          }
          if (!dirtyFields?.price_min && validQueryParams?.pub_price_min) {
            formRenderProps?.form?.change(
              'price_min_max',
              validQueryParams?.pub_price_min.split(',')[1]
            );
            setFilters({
              pub_price_min_max: validQueryParams?.pub_price_min.split(',')[1],
            });
          }

          if (!dirtyFields?.price_max && validQueryParams?.pub_price_max) {
            formRenderProps?.form?.change(
              'price_max_min',
              validQueryParams?.pub_price_max.split(',')[0]
            );
            setFilters({
              pub_price_max_min: validQueryParams?.pub_price_max.split(',')[0],
            });
          }
          if (!dirtyFields?.price_max && validQueryParams?.pub_price_max) {
            formRenderProps?.form?.change(
              'price_max_max',
              validQueryParams?.pub_price_max.split(',')[1]
            );
            setFilters({
              pub_price_max_max: validQueryParams?.pub_price_max.split(',')[1],
            });
          }

          const yearsOfExp = validQueryParams?.pub_years_of_experience?.split(',');
          if (!dirtyFields?.years_min && yearsOfExp?.[0].length > 0) {
            formRenderProps?.form?.change('years_min', yearsOfExp[0]);
            setFilters({
              pub_years_min: yearsOfExp[0],
            });
          }
          if (!dirtyFields?.years_max && yearsOfExp?.[1].length > 0) {
            formRenderProps?.form?.change('years_max', yearsOfExp[1]);
            setFilters({
              pub_years_max: yearsOfExp[1],
            });
          }
          const languagesTmp = validQueryParams?.pub_languages?.replace('has_all:', '').split(',');
          if (!dirtyFields?.languages && languagesTmp?.length > 0) {
            formRenderProps?.form?.change('languages', languagesTmp);
            setFilters({
              pub_languages: languagesTmp,
            });
          }
          setDirtyOverride(true);
        }
        return (
          <div className={css.root}>
            <MottoCard />
            <FieldTextInput
              id="keywords"
              key="keywords"
              name="keywords"
              placeholder={formatMessage({
                id: 'Cappa.filters.namePlaceholder',
                defaultMessage: 'Search through descriptions',
              })}
              onChange={e => {
                formRenderProps?.form?.change('keywords', e.target.value);
                console.log(e.target.value);
                setFilters({
                  keywords: e.target.value === '' ? null : e.target.value,
                });
              }}
              onKeyPress={onEnterKey}
            />
            <LocationField setFilters={setFilters} />
            <ServicesField setFilters={setFilters} onKeyPress={onEnterKey} />
            <div>
              <label htmlFor={'priceRangeMin'}>
                <FormattedMessage
                  id="Cappa.filters.priceRangeMinLabel"
                  defaultMessage={'Minimum price range (USD)'}
                />
              </label>
              <div id="priceRangeMin" className={css.priceRange}>
                <FieldTextInput
                  type="number"
                  id="price_min_min"
                  name="price_min_min"
                  placeholder="5"
                  min={0}
                  max={100000}
                  className={css.priceInput}
                  onChange={e => {
                    formRenderProps?.form?.change('price_min_min', e.target.value);
                    setFilters({
                      pub_price_min_min: e.target.value,
                    });
                  }}
                  onKeyPress={onEnterKey}
                />
                <FieldTextInput
                  type="number"
                  id="price_min_max"
                  name="price_min_max"
                  min={0}
                  max={100000}
                  placeholder="150"
                  className={css.priceInput}
                  onChange={e => {
                    formRenderProps?.form?.change('price_min_max', e.target.value);
                    setFilters({
                      pub_price_min_max: e.target.value,
                    });
                  }}
                  onKeyPress={onEnterKey}
                />
              </div>
            </div>
            <div>
              <label htmlFor={'priceRangeMax'}>
                <FormattedMessage
                  id="Cappa.filters.priceRangeMaxLabel"
                  defaultMessage={'Maximum price range (USD)'}
                />
              </label>
              <div id="priceRangeMax" className={css.priceRange}>
                <FieldTextInput
                  type="number"
                  id="price_max_min"
                  name="price_max_min"
                  placeholder="800"
                  min={0}
                  max={100000}
                  className={css.priceInput}
                  onChange={e => {
                    formRenderProps?.form?.change('price_max_min', e.target.value);
                    setFilters({
                      pub_price_max_min: e.target.value,
                    });
                  }}
                  onKeyPress={onEnterKey}
                />
                <FieldTextInput
                  type="number"
                  id="price_max_max"
                  name="price_max_max"
                  min={0}
                  max={100000}
                  placeholder="1600"
                  className={css.priceInput}
                  onChange={e => {
                    formRenderProps?.form?.change('price_max_max', e.target.value);
                    setFilters({
                      pub_price_max_max: e.target.value,
                    });
                  }}
                  onKeyPress={onEnterKey}
                />
              </div>
            </div>

            <div>
              <label htmlFor={'yearsRange'}>
                <FormattedMessage
                  id="Cappa.filters.yearsOfExperienceLabel"
                  defaultMessage={'Years of experience'}
                />
              </label>
              <div id="yearsRange" className={css.priceRange}>
                <FieldTextInput
                  type="number"
                  id="years_min"
                  name="years_min"
                  placeholder="0"
                  min={0}
                  max={100}
                  onChange={e => {
                    formRenderProps?.form?.change('years_min', e.target.value);
                    setFilters({
                      pub_years_min: e.target.value,
                    });
                  }}
                  onKeyPress={onEnterKey}
                />
                <FieldTextInput
                  type="number"
                  id="years_max"
                  name="years_max"
                  placeholder="10"
                  min={0}
                  max={100}
                  onChange={e => {
                    formRenderProps?.form?.change('years_max', e.target.value);
                    setFilters({
                      pub_years_max: e.target.value,
                    });
                  }}
                  onKeyPress={onEnterKey}
                />
              </div>
            </div>
            <div>
              <label htmlFor={'background_check'}>
                <FormattedMessage
                  id="Cappa.filters.backgroundCheckLabel"
                  defaultMessage={'Background check'}
                />
              </label>
              <FieldCheckbox
                id="background_check"
                name="background_check"
                type="checkbox"
                label={formatMessage({
                  id: 'Cappa.filters.backgroundCheckMessage',
                  defaultMessage: 'Display only verified',
                })}
                onChange={e => {
                  formRenderProps?.form?.change('background_check', e.target.checked);
                  setFilters({
                    pub_background_check: e.target.checked ? 'yes' : null,
                  });
                }}
                onKeyPress={onEnterKey}
              />
            </div>
            <div>
              <label htmlFor={'languages'}>
                <FormattedMessage
                  id="Cappa.filters.languaguesLabel"
                  defaultMessage={'Languagues'}
                />
              </label>
              <FieldCheckboxGroup
                name="languages"
                id={'languages'}
                options={[
                  {
                    key: 'english',
                    label: flags.english + '  English',
                  },
                  {
                    key: 'spanish',
                    label: flags.spanish + '  Spanish',
                  },
                  {
                    key: 'french',
                    label: flags.french + '  French',
                  },
                  {
                    key: 'portuguese',
                    label: flags.portuguese + '  Portuguese',
                  },
                  {
                    key: 'chinese',
                    label: flags.chinese + '  Chinese',
                  },
                  {
                    key: 'japanese',
                    label: flags.japanese + '  Japanese',
                  },
                  {
                    key: 'tagalog',
                    label: flags.tagalog + '  Tagalog',
                  },
                  {
                    key: 'vietnamese',
                    label: flags.vietnamese + '  Vietnamese',
                  },
                  {
                    key: 'asl',
                    label: flags.asl + ' American Sign Language (ASL)',
                  },
                ]}
                onChange={e => {
                  formRenderProps?.form?.change('languages', e);
                  setFilters({
                    pub_languages: e,
                  });
                }}
              />
            </div>
          </div>
        );
      }}
    ></FinalForm>
  );
};

const ServicesField = ({ setFilters, ...rest }) => {
  const config = useConfiguration();
  const configOptions = config?.listing?.listingFields
    ?.find(field => field.key === 'services')
    ?.enumOptions?.map(options => ({
      value: options.option,
      label: options.label,
    }));
  const { formatMessage } = useIntl();
  const field = useField('services', {
    type: 'select',
    multiple: true,
  });
  const defaultValue =
    field?.input?.value?.map?.(v => ({
      value: v,
      label: configOptions?.find?.(option => option.value === v)?.label,
    })) || [];
  return (
    <div>
      <label htmlFor={'services'}>
        <FormattedMessage id="Cappa.filters.servicesLabel" defaultMessage={'Services'} />
      </label>
      <Select
        id="services"
        placeholder={formatMessage({
          id: 'Cappa.filters.servicesPlaceholder',
          defaultMessage: 'All services',
        })}
        defaultValue={defaultValue}
        onChange={e => {
          field?.input?.onChange(e);
          setFilters({
            pub_services: e?.map(v => v.value),
          });
        }}
        options={configOptions || []}
        isMulti
        classNames={{
          control: () => css.control,
          input: () => css.input,
          option: () => css.option,
          multiValueLabel: () => css.multiValueLabel,
          multiValueRemove: () => css.multiValueRemove,
          multiValue: () => css.multiValue,
          placeholder: () => css.placeholder,
        }}
        unstyled
        {...rest}
      />
    </div>
  );
};

export default CappaFilterPanel;
